import { render, staticRenderFns } from "./TransactionRecord.vue?vue&type=template&id=36ae905a&scoped=true"
import script from "./TransactionRecord.vue?vue&type=script&lang=js"
export * from "./TransactionRecord.vue?vue&type=script&lang=js"
import style0 from "./TransactionRecord.vue?vue&type=style&index=0&id=36ae905a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae905a",
  null
  
)

export default component.exports